const Debug = {}

;['log', 'debug', 'error', 'warn', 'group', 'table', 'time', 'timeEnd'].forEach(
  key =>
    (Debug[key] = (...args) =>
      localStorage.SavvyDebugMode === 'true' ? console[key](...args) : null)
)

export default Debug
